import { forwardRef } from "react";

import styled from "styled-components";

import { useHasPrayerRequests } from "Flocknote/stateHooks";

import DefaultInquiryButton from "./DefaultInquiryButton";
import GeneralInquiryButton from "./GeneralInquiryButton";
import PrayerRequestButton from "./PrayerRequestButton";
import { useShouldShowDefaultInquiry } from "./stateHooks";

const MainOptions = forwardRef((props, ref) => {
  const shouldShowDefaultInquiry = useShouldShowDefaultInquiry();
  const [hasPrayerRequests] = useHasPrayerRequests();

  return (
    <Wrapper ref={ref}>
      <MainMainOptions>
        {shouldShowDefaultInquiry && <DefaultInquiryButton />}
        <GeneralInquiryButton />
        {Boolean(hasPrayerRequests) && <PrayerRequestButton />}
      </MainMainOptions>
    </Wrapper>
  );
});

const MainMainOptions = styled.div`
  display: flex;
  margin-top: -6px;
  gap: 4px;
  flex-direction: column;
`;

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  width: min(378px, calc(100vw - 66px));
  transition: width 300ms;
`;

export default MainOptions;
